import { Link, Navigate, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function ClienteCard({key, id, numCliente, nombre, cuitCuilDni, ciudad, direccion, cp, zona, telefono, notas}){
    const navigate = useNavigate();

    const handleLink = () => {
        navigate(`/clienteDetalle/${id}`)
    }

    return(
        <>
            <table>
                <tbody>
                <tr className="text-sky-300 text-[10pt] font-semibold border-b border-slate-400 hover:font-bold hover:text-yellow-300 cursor-pointer"
                    onClick={handleLink}
                >                
                    <td className="w-[60px] text-center">{numCliente}</td>
                    <td className="w-[300px]">{nombre}</td>                    
                    <td className="w-[100px]">{cuitCuilDni}</td>
                    <td className="w-[150px]">{ciudad}</td>
                    <td className="w-[150px]">{direccion}</td>
                    <td className="w-[50px]">{cp}</td>
                    <td className="w-[50px]">{zona}</td>
                    <td className="w-[150px]">{telefono}</td>
                    <td className="w-[173px]">{notas}</td>                
                </tr>
                </tbody>
            </table>
        </>
    )
}